import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

const pageAnim = (() => {
  const pageLoading = () => {
    document.addEventListener("DOMContentLoaded", function () {
      let percent = 0;
      const loadingScreen = document.querySelector(".page-loading");
      const percentText = document.querySelector(".percent");
      const percentBar = document.querySelector(".bar-loading");
  
      if (!percentText || !percentBar) {
          // console.error('percentText veya percentBar elementi bulunamadı.');
          return;
      }
  
      function updateLoading() {
          if (percent < 90) {
              percent += 1;
              percentText.textContent = `%${percent}`;
              percentBar.style.width = `${percent}%`;
              setTimeout(updateLoading, 50);
          }
      }
      
      updateLoading();
      
      window.addEventListener("load", function () {
          percent = 100;
          percentText.textContent = `%${percent}`;
          percentBar.style.width = `${percent}%`;
          setTimeout(() => loadingScreen.classList.remove("active-loading"), 500);
      });
    });
  };
  
  const modalTrigger = () => {
    //Modal açma
    document.querySelectorAll('.open-modal').forEach(button => {
      button.addEventListener('click', function() {
        const modalId = this.getAttribute('data-modal');
        document.getElementById(modalId).classList.remove('hidden');
        document.body.classList.add('overflow-hidden');
      });
    });
  
    // Modal kapama
    document.querySelectorAll('.close-modal').forEach(button => {
      button.addEventListener('click', function() {
        const modal = this.closest('.fixed');
        modal.classList.add('hidden');
        document.body.classList.remove('overflow-hidden');
      });
    });
  
    // Modal arka planına tıklama
    document.querySelectorAll('.modal-backdrop').forEach(modal => {
      modal.addEventListener('click', function(event) {
        if (event.target === this && !this.classList.contains('no-click')) {
          const modalContainer = this.closest('.pg-ld-modal');
          modalContainer.classList.add('hidden');
        }
      });
    });
  };

  const copyNumberBtn = () => {
    const copyButtons = document.querySelectorAll('.copy-number');

    copyButtons.forEach(button => {
        button.addEventListener('click', () => {
            const numberToCopy = button.getAttribute('data-copy-number');
            const copySuccessText = button.getAttribute('data-copy-success-text') || 'Kopyalandı';
            const copyErrorText = button.getAttribute('data-copy-error-text') || 'Kopyalama Başarısız';
            
            // Debug için console.log ekleyelim
            console.log('copySuccessText:', copySuccessText);
            console.log('copyErrorText:', copyErrorText);
            
            navigator.clipboard.writeText(numberToCopy)
                .then(() => {
                    const messageDiv = document.createElement('div');
                    messageDiv.className = 'copy-message';
                    messageDiv.innerHTML = copySuccessText;
                    
                    // Debug için
                    console.log('messageDiv.innerHTML:', messageDiv.innerHTML);
                    
                    button.style.position = 'relative';
                    
                    const existingMessages = button.querySelectorAll('.copy-message');
                    existingMessages.forEach(msg => msg.remove());
                    
                    button.appendChild(messageDiv);
                    
                    setTimeout(() => {
                        if (messageDiv.parentNode) {
                            messageDiv.remove();
                        }
                    }, 1500);
                })
                .catch(err => {
                    const errorDiv = document.createElement('div');
                    errorDiv.className = 'copy-message';
                    errorDiv.innerHTML = copyErrorText;
                    
                    // Debug için
                    console.log('errorDiv.innerHTML:', errorDiv.innerHTML);
                    button.style.position = 'relative';
                    
                    const existingMessages = button.querySelectorAll('.copy-message');
                    existingMessages.forEach(msg => msg.remove());
                    
                    button.appendChild(errorDiv);
                    
                    setTimeout(() => {
                        if (errorDiv.parentNode) {
                            errorDiv.remove();
                        }
                    }, 1500);
                });
        });
    });

  };

  const fancyApps = () => {
    var kvkkFillDiv = document.getElementById('kvkk-fill');
    var kabulEdiyorumButton = document.querySelector('.apply-kvkk');
    Fancybox.bind("[data-fancybox]", {
      Thumbs: false,
    });
    $(".apply-reject, .apply-kvkk").on("click", function(){
      Fancybox.close();
    });
    Fancybox.bind('[data-fancybox="person"]', {
      groupAll: false, 
      Thumbs: false,
      Toolbar:false,
      Hash: false,
      // Carousel:false,
      groupAttr: false,
      on: {
          reveal: (fancybox, slide) => {
              const trigger = slide.triggerEl;
              const name = trigger.getAttribute('data-name');
              const job = trigger.getAttribute('data-job');
              const year = trigger.getAttribute('data-year');
              const img = trigger.getAttribute('data-img');
              const desc = trigger.getAttribute('data-desc');
              
              $("#person-popup .person-name").html(name);
              $("#person-popup #person-job").html(job);
              if (year) {
                  $("#person-popup #person-year").html(year).show();
              } else {
                  $("#person-popup #person-year").html("").hide();
              }
              $("#person-popup .person-img img").attr('src', img);
              $("#person-popup .person-caption").html(desc);
          }
      },
      dragToClose: false
    });
  };

  const androidIosDownloadBtn = () => {
    document.addEventListener("DOMContentLoaded", function() {
      var isAndroid = /Android/i.test(navigator.userAgent);
      var isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      if(document.querySelector('.googlplay')){
        if (isAndroid) {
            document.querySelector('.googlplay').style.display = 'block';
            document.querySelector('.appstore').style.display = 'none';
        } else if (isIOS) {
            document.querySelector('.appstore').style.display = 'block';
            document.querySelector('.googlplay').style.display = 'none';
        } else {
            // document.querySelector('.appstore').style.display = 'block';
            // document.querySelector('.googlplay').style.display = 'block';
        }
      }
    });
  };

  const pageBottomFixedElement = () => {
    const adjustFixedElements = () => {
        const fixedElements = document.querySelectorAll('.page-bottom-fixed-element');
        if (!fixedElements.length) return;

        // Her element için pozisyonu yeniden hesapla
        fixedElements.forEach((element, index) => {
            if (index === 0) {
                // İlk element için
                const firstElementTop = window.innerWidth >= 992 ? 200 : 15;
                element.style.setProperty('top', `${firstElementTop}px`, 'important');
            } else {
                // Diğer elementler için
                const previousElement = fixedElements[index - 1];
                const previousTop = parseInt(previousElement.style.top);
                const newTop = previousTop + previousElement.offsetHeight + 30;
                element.style.setProperty('top', `${newTop}px`, 'important');
            }
        });
    };

    // Close butonları için event listener
    document.querySelectorAll('.close-fixed-element').forEach(closeButton => {
        closeButton.addEventListener('click', (e) => {
            const fixedElement = e.currentTarget.closest('.page-bottom-fixed-element');
            if (fixedElement) {
                fixedElement.remove();
                setTimeout(adjustFixedElements, 0);
            }
        });
    });

    // Element görünürlüğünü izle
    const observer = new MutationObserver(() => {
        adjustFixedElements();
    });

    document.querySelectorAll('.page-bottom-fixed-element').forEach(element => {
        observer.observe(element, {
            attributes: true,
            attributeFilter: ['class']
        });
    });

    // İlk yüklemede ve pencere boyutu değiştiğinde çalıştır
    adjustFixedElements();
    window.addEventListener('resize', adjustFixedElements);
  };

  const pageCustomSelect = () => {
    var x, i, j, l, ll, selElmnt, a, b, c;
    /*look for any elements with the class "custom-select":*/
    x = document.getElementsByClassName("custom-select");
    l = x.length;
    for (i = 0; i < l; i++) {
      selElmnt = x[i].getElementsByTagName("select")[0];
      ll = selElmnt.length;
      /*for each element, create a new DIV that will act as the selected item:*/
      a = document.createElement("DIV");
      a.setAttribute("class", "select-selected");
      a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
      x[i].appendChild(a);
      /*for each element, create a new DIV that will contain the option list:*/
      b = document.createElement("DIV");
      b.setAttribute("class", "select-items select-hide");
      
      // Eğer searchable class'ı varsa arama input'u ekle
      if (x[i].classList.contains('searchable')) {
        const searchInput = document.createElement("INPUT");
        searchInput.setAttribute("type", "text");
        searchInput.setAttribute("placeholder", "Ara...");
        searchInput.setAttribute("class", "select-search-input");
        
        searchInput.addEventListener("input", function() {
          const searchTerm = this.value.toLowerCase();
          // Sadece bu arama input'unun bulunduğu select container'ındaki option'ları filtrele
          const currentSelectContainer = this.closest('.custom-select');
          const currentOptionsContainer = currentSelectContainer.querySelector('.select-items');
          const options = currentOptionsContainer.querySelectorAll("div:not(.select-search-input)");
          
          options.forEach(option => {
            const text = option.innerHTML.toLowerCase();
            if (text.includes(searchTerm)) {
              option.style.display = "";
            } else {
              option.style.display = "none";
            }
          });
        });
        
        // Input'a tıklandığında dropdown'ın kapanmasını engelle
        searchInput.addEventListener("click", function(e) {
          e.stopPropagation();
        });
        
        b.appendChild(searchInput);
      }
      
      for (j = 1; j < ll; j++) {
        /*for each option in the original select element,
        create a new DIV that will act as an option item:*/
        c = document.createElement("DIV");
        c.innerHTML = selElmnt.options[j].innerHTML;
        c.addEventListener("click", function(e) {
          /*when an item is clicked, update the original select box,
          and the selected item:*/
          var y, i, k, s, h, sl, yl;
          s = this.parentNode.parentNode.getElementsByTagName("select")[0];
          sl = s.length;
          h = this.parentNode.previousSibling;
          for (i = 0; i < sl; i++) {
            if (s.options[i].innerHTML == this.innerHTML) {
              s.selectedIndex = i;
              h.innerHTML = this.innerHTML;
             
             
              // Progress bar'ı güncelle
              handleProgressSelectChange(
                  s.name || s.id || 'isimsiz select',
                  this.innerHTML
              );
             
              y = this.parentNode.getElementsByClassName("same-as-selected");
              yl = y.length;
              for (k = 0; k < yl; k++) {
                y[k].removeAttribute("class");
              }
              this.setAttribute("class", "same-as-selected");
              break;
            }
          }
          h.click();
        });
        b.appendChild(c);
      }
      x[i].appendChild(b);
      a.addEventListener("click", function(e) {
          /*when the select box is clicked, close any other select boxes,
          and open/close the current select box:*/
          e.stopPropagation();
          closeAllSelect(this);
          this.nextSibling.classList.toggle("select-hide");
          this.classList.toggle("select-arrow-active");
        });
    }
    function closeAllSelect(elmnt) {
      /*a function that will close all select boxes in the document,
      except the current select box:*/
      var x, y, i, xl, yl, arrNo = [];
      x = document.getElementsByClassName("select-items");
      y = document.getElementsByClassName("select-selected");
      xl = x.length;
      yl = y.length;
      for (i = 0; i < yl; i++) {
        if (elmnt == y[i]) {
          arrNo.push(i)
        } else {
          y[i].classList.remove("select-arrow-active");
        }
      }
      for (i = 0; i < xl; i++) {
        if (arrNo.indexOf(i)) {
          x[i].classList.add("select-hide");
        }
      }
    }
    /*if the user clicks anywhere outside the select box,
    then close all select boxes:*/
    document.addEventListener("click", closeAllSelect);
  };

  const simpleCustomSelect = () => {
    // Targets containers with class "simple-custom-select" and the first <select> inside
    const containers = document.getElementsByClassName('simple-custom-select');
    for (let i = 0; i < containers.length; i += 1) {
      const container = containers[i];
      const nativeSelect = container.getElementsByTagName('select')[0];
      if (!nativeSelect || nativeSelect.dataset.simpleEnhanced === 'true') continue;

      // Selected label element
      const selectedDiv = document.createElement('DIV');
      selectedDiv.setAttribute('class', 'simple-select-selected');
      selectedDiv.innerHTML = nativeSelect.options[nativeSelect.selectedIndex]?.innerHTML || '';
      container.appendChild(selectedDiv);

      // Dropdown container
      const itemsDiv = document.createElement('DIV');
      itemsDiv.setAttribute('class', 'simple-select-items simple-select-hide');

      // Optional: search input if container has class 'is-searchable'
      if (container.classList.contains('is-searchable')) {
        const searchInput = document.createElement('INPUT');
        searchInput.setAttribute('type', 'text');
        searchInput.setAttribute('placeholder', 'Ara...');
        searchInput.setAttribute('class', 'simple-select-search-input');
        searchInput.onkeyup = function () {
          this.value = this.value.toUpperCase();
        };
        searchInput.addEventListener('input', function () {
          const term = this.value.toLowerCase();
          const optionDivs = itemsDiv.querySelectorAll('div.simple-option-item');
          optionDivs.forEach((opt) => {
            const txt = opt.textContent.toLowerCase();
            opt.style.display = txt.includes(term) ? '' : 'none';
          });
        });
        // Prevent closing when interacting with search input
        searchInput.addEventListener('click', function (e) { e.stopPropagation(); });
        itemsDiv.appendChild(searchInput);
      }

      // Build options
      for (let j = 0; j < nativeSelect.options.length; j += 1) {
        const opt = nativeSelect.options[j];
        const optionDiv = document.createElement('DIV');
        optionDiv.setAttribute('class', 'simple-option-item');
        optionDiv.innerHTML = opt.innerHTML;
        if (opt.disabled) optionDiv.classList.add('is-disabled');
        optionDiv.addEventListener('click', function () {
          if (opt.disabled) return;
          // Update native select
          nativeSelect.selectedIndex = j;
          selectedDiv.innerHTML = this.innerHTML;

          // Mark selected style
          itemsDiv.querySelectorAll('.same-as-selected').forEach((el) => {
            el.classList.remove('same-as-selected');
          });
          this.setAttribute('class', 'simple-option-item same-as-selected');

          // Dispatch change for listeners
          const evt = new Event('change', { bubbles: true });
          nativeSelect.dispatchEvent(evt);

          // Close dropdown
          selectedDiv.click();
        });
        itemsDiv.appendChild(optionDiv);
      }

      container.appendChild(itemsDiv);

      selectedDiv.addEventListener('click', function (e) {
        e.stopPropagation();
        closeAllSimpleSelect(this);
        this.nextSibling.classList.toggle('simple-select-hide');
        this.classList.toggle('simple-select-arrow-active');
      });

      // Mark as enhanced to avoid double-init
      nativeSelect.dataset.simpleEnhanced = 'true';
      // Hide native select visually but keep in DOM for forms
      nativeSelect.style.display = 'none';
    }

    function closeAllSimpleSelect(current) {
      const panels = document.getElementsByClassName('simple-select-items');
      const labels = document.getElementsByClassName('simple-select-selected');
      for (let i = 0; i < labels.length; i += 1) {
        if (current === labels[i]) continue;
        labels[i].classList.remove('simple-select-arrow-active');
      }
      for (let i = 0; i < panels.length; i += 1) {
        if (current && panels[i] === current.nextSibling) continue;
        panels[i].classList.add('simple-select-hide');
      }
    }

    document.addEventListener('click', function () {
      closeAllSimpleSelect(null);
    });
  }
  
  const activateProgressStep = (stepName,selectedText) => {
   
    const progressSteps = document.querySelectorAll('.progress-step');
    const progressLabels = document.querySelectorAll('.progress-label');
    const progressCircles = document.querySelectorAll('.progress-circle');
   
    // Adım ismini bul ve aktif yap
    progressLabels.forEach((label, index) => {
      if (label.getAttribute('name') == stepName) {
        progressSteps[index].classList.add('active');
        progressCircles[index].classList.add('active');
        label.classList.add('active');
        label.innerHTML = selectedText;
      }
    });
  };
 
  const handleProgressSelectChange = (selectName, selectedText) => {
    activateProgressStep(selectName,selectedText);
  };

  const init = () => {
    pageLoading();
    modalTrigger();
    copyNumberBtn();
    fancyApps();
    androidIosDownloadBtn();
    pageBottomFixedElement();
    // pageCustomSelect();
    simpleCustomSelect();
  };

  return {
    init,
  };
})();

export default pageAnim;
